import React from 'react';
import RydHeaderDialogBox from '../RydHeaderDialogBox';
export function RydNumericInput({
    label,
    value,
    setValue,
    min = 0,
    max = 100,
    step = 1,
    valueDisplayPostProcessor = (v) => `${v}`
}: {
    label?: string,
    value: number,
    setValue: (value?: number) => void,
    min?: number,
    max?: number,
    step?: number,
    valueDisplayPostProcessor?: (value: number) => string
}) {

    const [collapsed, setCollapsed] = React.useState(true);
    const ppValue = valueDisplayPostProcessor(value);
    if (collapsed) {
        return (<button onClick={() => setCollapsed(!collapsed)}>
            {label ? `${label}: ${ppValue}` : ppValue}
        </button>);
    }

    return (
        <RydHeaderDialogBox closeCB={() => {
            setCollapsed(!collapsed);
            setValue(value);
        }}>
            <>
                <label>{label}</label>
                <input
                    type="number"
                    defaultValue={value}
                    onChange={(e) => setValue(Number(e.target.value))}
                    min={min}
                    max={max}
                    step={step}
                />
            </>
        </RydHeaderDialogBox>
    );
}